/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
// core components
import NotificationAlert from "react-notification-alert";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import AppNavBar from "./AppNavBar";
import ReviewForm from "./pages/reviews/ReviewForm";
import auditService from "../services/auditService.js";
import AuditForm from "./pages/audit/AuditForm";
import AdminService from "../services/adminService";
import Loader from "./Loader";
import AdminForm from "./pages/admin/Form";
import axios from "axios";
import AuthService from "../services/authService.js";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
      password: "",
      confirmPassword: "",
      loading: false,
      loginModal: false,
      errorData: {},
    };
    this.notify = this.notify.bind(this);
  }

  componentDidMount() {
    const token = this.props.match.params.token;
    console.log(token)
    if (token) {
      this.setState({ token });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { token, password, confirmPassword } = this.state;
    if (!token || !password || !confirmPassword) {
      this.notify("danger", "ERROR", "All fields are required!");
      return;
    }
    this.setState({ loading: true });
    const data = {
        token : this.state.token, password : this.state.password, confirmPassword: this.state.confirmPassword
    }
    AuthService.resetPassword(data)
      .then((response) => {
        if (response && response.responseStatus === "SUCCESS") {
          this.notify(
            "success",
            "Password Reset",
            "Your password has been reset successfully!"
          );
          setTimeout(() => {
            this.props.history.push("/");
          }, 2500);
        } else {
          this.notify(
            "danger",
            "ERROR",
            response.message || "Failed to reset password."
          );
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.notify("danger", "ERROR", "Failed to reset password.");
        this.setState({ loading: false });
      });
  };

  fileChange = (event) => {
    this.setState({ file: event.target.files[0] });
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    return (
      <div style={{ backgroundColor: "white" }}>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <AppNavBar loginModalToggle={this.toggleModal} />
        {/* Hero Banner */}
        <div className="hero-banner" style={{ height: "256px" }}>
          <Container fluid>
            <Row>
              <Col>
                <div className="hero-banner-content">
                  <p style={{ textAlign: "start" }}>Reset Password</p>
                  <h1 style={{ textAlign: "start" }}>
                    Reset your account password
                  </h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <br />
        <br />
        <br />
        <Container className="mt--6" fluid>
          <Card className="mb-4">
            {this.state.loading && <Loader />}
            <CardBody>
              <Row>
                <Col md={4}></Col>
                <Col md={4}>
                  <CardHeader>
                    <h3 className="mb-0 text-center">Reset Your Password</h3>
                  </CardHeader>
                </Col>
                <Col md={4}></Col>
              </Row>
              <Row>
                <Col md={4}></Col>
                <Col md={4}>
                  <Form role="form" onSubmit={this.handleSubmit}>
                    
                    <div className="form-group">
                      <label htmlFor="password">New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        placeholder="Enter new password"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="confirmPassword">
                        Confirm New Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={this.state.confirmPassword}
                        onChange={this.handleChange}
                        placeholder="Confirm new password"
                        required
                      />
                    </div>
                    <div className="text-center">
                      <Button
                        className="my-4"
                        color="default"
                        outline
                        type="submit"
                        disabled={this.state.loading}
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </Col>
                <Col md={4}></Col>
              </Row>
            </CardBody>
          </Card>
        </Container>

        <Modal
          // size={"lg"}
          className="modal-dialog-centered"
          isOpen={this.state.loginModal}
          toggle={() => this.toggleModal("loginModal")}
        >
          <Login />
        </Modal>

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <footer className="py-5" id="footer-main">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="6">
                <div className="copyright text-center text-xl-left text-muted">
                  © {new Date().getFullYear()}{" "}
                  <a
                    className="font-weight-bold ml-1"
                    href="https://sekim-international.com/"
                    target="_blank"
                  >
                    Sekim International
                  </a>
                </div>
              </Col>
              <Col xl="6">
                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                  <NavItem>
                    <NavLink href="https://xaregrowth.com" target="_blank">
                      XareGrowth
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href=""
                      target="_blank"
                      onClick={(event) => {
                        this.props.history.push("/aboutUs");
                      }}
                    >
                      About Us
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    );
  }
}

export default ResetPassword;
